import { render, staticRenderFns } from "./selection-list.vue?vue&type=template&id=7f27d594&scoped=true&"
import script from "./selection-list.ts?vue&type=script&lang=ts&"
export * from "./selection-list.ts?vue&type=script&lang=ts&"
import style0 from "./selection-list.scss?vue&type=style&index=0&id=7f27d594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27d594",
  null
  
)

export default component.exports